<template>
    <div class="d-flex align-center justify-md-end">
        <span class="mr-2 text-body-2">{{ $t('show_trip_plans_for').toLowerCase() }}</span>
        <v-select
            v-model="model"
            :items="list"
            :label="$t('order_travelers')"
            clearable
            density="compact"
            hide-details
            style="max-width: 200px"
            class="ml-auto ml-sm-0 mt-0 cursor-pointer"
            @update:model-value="$emit('change', model)"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class OrderDetailsTravelersFilter extends Vue {
        @Prop({required: true, type: Array}) orderTravelers

        model = null

        get list() {
            return this.orderTravelers
                .map(t => ({
                    ...t,
                    title: `${t.name[0]?.firstName ? t.name[0].firstName : ''} ${
                        t.name[0].lastName ? t.name[0].lastName : ''
                    }`,
                }))
                .sort((a, b) =>
                    a.name[0].lastName === b.name[0].lastName
                        ? a.name[0].firstName - b.name[0].firstName
                            ? 1
                            : -1
                        : a.name[0].lastName - b.name[0].lastName
                          ? 1
                          : -1
                )
        }
    }

    export default OrderDetailsTravelersFilter
</script>
